module.exports = __webpack_public_path__ + "img/CS26Q-中_02.4489dec0.jpg";